import React from "react";
import { useNavigate } from "react-router-dom";
import "./CompaniesSection.css";

import SolarImg from "../../assets/Services/solar.png";
import LandImg from "../../assets/Services/land.png";
import Greenenergy from "../../assets/Services/Cm-Green-energy-logo.png";
import Promoters from "../../assets/Services/Cm-promoters-logo.png";

const CompaniesSection = () => {
  const navigate = useNavigate();

  const cards = [
    {
      id: 1,
      cardClass: "cm-card-green",
      logo: Greenenergy,
      title: "Solar Powering India's Sustainable Future.",
      description:
        "Powering India’s transition to a sustainable future. We deliver high-performance, reliable solar systems that drastically reduce energy costs and environmental footprints for homes, businesses, and industries nationwide.",
      image: SolarImg,
      link: "/green-energy/greenenergy",
    },
    {
      id: 2,
      cardClass: "cm-card-blue",
      logo: Promoters,
      title: "Quality Construction. Lasting Value. CM Developers.",
      description:
        "CM Promoters & Developers focuses on creating high-quality, strategically-located properties that offer significant growth opportunities.",
      image: LandImg,
      link: "/developers/promoters",
    },
  ];

  return (
    <div className="cm-companies-section-bg">
      <section className="cm-companies-section">
        <h2 className="cm-section-title">Our Companies Solution</h2>

        <div className="cm-company-cards-wrapper">
          {cards.map((item) => (
            <div key={item.id} className={`cm-company-card ${item.cardClass}`}>
              <div className="cm-card-content">
                <img
                  src={item.logo}
                  alt="Company Logo"
                  className="cm-company-logo"
                />
                <h3 className="cm-card-title">{item.title}</h3>
                <p className="cm-card-description">{item.description}</p>
              </div>

              <div className="cm-image-wrapper">
                <img
                  src={item.image}
                  alt={item.title}
                  className="cm-card-image"
                />
                <button
                  className="cm-card-button"
                  onClick={() => navigate(item.link)}
                >
                  Discover more
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default CompaniesSection;
